
import { docStatusToTagColor  } from '@src/constants'
import Tag from '../Tag/Tag'

export default function DocStatusTag ({ children: status, ...props }) {
  return <Tag {...props} color={docStatusToTagColor(status)}>{status}</Tag>
}
